import React, { useCallback } from 'react'
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { MainButton } from '../../Button/MainButton'
import { DangerButton } from '../../Button/DangerButton'

const ExitWizardDialog = ({
	open,
	onExit,
	onCancel,
	exitLabel = 'Save and Exit',
	title = 'Exit Wizard?',
	description = ''
}) => {
	const classes = useStyles()

	const handleOnExit = useCallback(() => {
		if (onExit) {
			onExit()
		}
	}, [onExit])

	const handleOnCancel = useCallback(() => {
		if (onCancel) {
			onCancel()
		}
	}, [onCancel])

	return (
		<Dialog
			open={open}
			onClose={handleOnCancel}
			PaperProps={{
				style: {
					padding: 0,
					minWidth: 448,
					maxWidth: 448,
					minHeight: 250
				}
			}}>
			<DialogTitle>
				<div className={classes.header}>
					<div className={classes.titleContainer}>{title}</div>
				</div>
			</DialogTitle>
			<DialogContent className={classes.sectionPadding}>
				<div>{description}</div>
				<div className={classes.buttonContainer}>
					<DangerButton color="primary" label={exitLabel} onClick={handleOnExit} />
					<MainButton label="Cancel" onClick={handleOnCancel} />
				</div>
			</DialogContent>
		</Dialog>
	)
}

const useStyles = makeStyles(() => ({
	header: {
		display: 'flex',
		alignItems: 'center',
		padding: '1.1rem 1.5rem',
		gap: '.8rem'
	},
	sectionPadding: {
		padding: '1.5rem',
		paddingTop: 0,
		display: 'flex',
		flexDirection: 'column',
		gap: '1rem',
		'& div:nth-child(1)': {
			flex: 1
		}
	},
	titleContainer: {
		flex: 1,
		fontFamily: 'Nunito',
		fontSize: '1rem'
	},
	buttonContainer: {
		display: 'flex',
		gap: '0.8rem'
	}
}))

export default ExitWizardDialog
